import axiosInstance from '../../shared/utils/axios';
import {_openModal} from '../../shared/store';
import lazy from 'lazy.js';

// eslint-disable-next-line no-unused-vars
// const log = debug('circleblack:advisor:partners');

const partners = lazy([]);

/* --- actions ---*/
const GET_PARTNERS = 'GET_PARTNERS';

/**
 * Dispatches GET_PARTNERS gathering the list of partners a user has available to them
 */
// ETODO Possibly need to update API to accept query params.
export const _getPartners = (force, params) => dispatch => partners.size() && !force
  ? dispatch({type: GET_PARTNERS, partners: partners})
  : axiosInstance.get('/partners', {params})
    .then(res => dispatch({type: GET_PARTNERS, partners: lazy(res.data)}))
    .catch((err) => dispatch(_openModal({type: 'Error', err})));

/* --- reducer ---*/
export default function reducer(state = partners, action) {
  let newState = {...state};

  switch (action.type) {
    case GET_PARTNERS:
      newState = action.partners;
      break;
    default:
      return state;
  }
  return newState;
}
